const sections = [];

sections.push(
	{
		name: 'login',
		paths: ['/login'],
		module: 'login',
		enableLoggedOut: true,
	},
{
        name: 'jwt-login',
        paths: ['/jwt-login'],
        module: 'login',
        enableLoggedOut: true,
    },
    {
        name: "connections",
        paths: ['/connections/[^\\/]+', '/connections/[^\\/]+/operations'],
        module: "dashboard/connections",
        enableLoggedOut: false
    },
    {
        name: "resources",
        paths: ['/resources'],
        module: "dashboard/resources",
        enableLoggedOut: false
    },
    {
        name: "settings",
        paths: ['/settings'],
        module: "dashboard/settings",
        enableLoggedOut: false
    },
    {
        name: 'dashboard',
        paths: ['/', "/dashboard",],
        module: 'dashboard',
        group: 'dashboard',
        enableLoggedOut: false
    },
    {
        name: "shopify-app/callback",
        paths: ['/sgc'],
        module: "app/shopify",
        enableLoggedOut: false,
        pageNotFound: false
    },
);

module.exports = sections;
